export default class InputPassword
{
    constructor($el, options = {}) {
        this.DOM = { $el }
        this.options = { ...InputPassword.prototype.defaults, ...options }
        this.init()
    }

    init() {
        this.DOM.$input = this.DOM.$el.querySelector(this.options.selectorInput)
        this.DOM.$toggle = this.DOM.$el.querySelector(this.options.selectorToggle)
        this.isVisible = false

        let eventNameDown = 'mousedown'
        let eventNameUp = 'mouseup'

        if ('ontouchstart' in document.documentElement) {
            eventNameDown = 'touchstart'
            eventNameUp = 'touchend'
        }

        this.DOM.$toggle.addEventListener(eventNameDown, () => {
            this.toggleVisibility()

            document.addEventListener(eventNameUp, () => {
                this.toggleVisibility()
            }, { once: true })
        })
    }

    toggleVisibility() {
        this.isVisible = !this.isVisible
        this.DOM.$el.classList.toggle(this.options.classNameIsVisible, this.isVisible)
        this.DOM.$input.type = (this.isVisible) ? 'text' : 'password'
        this.DOM.$input.focus()
    }
}

InputPassword.prototype.defaults = {
    classNameIsVisible: 'is-visible',
    selectorInput: '.js-inputPasswordInput',
    selectorToggle: '.js-inputPasswordToggle',
}